import VendDetect from '@vend/detect'
import angular from 'angular'
import 'angular-currency-filter'
import 'angular-messages'
import '@vend/angular-vs-repeat'

import '@vend/vend.js'

// Will add `vd-is-ios`, `vd-is-chrome`, etc style CSS classes to <html> element that can be used in CSS
VendDetect.addCssClasses({ prefix: 'vd' })

angular.module('vend.ui', [
  'vend.js',
  'currencyFilter',
  'ngMessages',
  'vs-repeat',
])
